import { createStyles } from 'antd-style';

import { ThemeColors, ThemeSpaces } from '../../../theme';
import { spaceBetween } from '../../../styles/mixins';

export const usePackageListPieceListStyles = createStyles(
  ({ token }, { twoLines } = {}) => ({
    pieceListDrawer: {
      [`.${twoLines}`]: {
        marginBottom: ThemeSpaces.SPACE_NORM_20,
      },
    },
    pieceListDrawerBottomControls: {
      padding: `${ThemeSpaces.SPACE_NORM}px ${ThemeSpaces.SPACE_NORM_20}px`,
      '.ant-btn-sm.ant-btn-primary': {
        width: 200,
      },
    },
    pieceListHeader: {
      height: 40,
      backgroundColor: ThemeColors.COLOR_GREY9_6,
      padding: `0 ${ThemeSpaces.SPACE_NORM}px`,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',

      '.label': {
        fontFamily: token.fontFamily,
        fontWeight: 500,
      },
      '.IconButton': {
        color: token.colorPrimary,
        display: 'block',
        fontSize: token.fontSizeHeading4,
      },
    },
    pieceListEditingList: {
      padding: `${ThemeSpaces.SPACE_NORM_20}px ${ThemeSpaces.SPACE_NORM_20}px ${ThemeSpaces.SPACE_NORM0_5}px ${ThemeSpaces.SPACE_NORM_20}px`,

      '> *': {
        ...spaceBetween(ThemeSpaces.SPACE_NORM_20, 'vertical'),
      },
    },
    pieceListPreviewRows: {
      padding: `0 ${ThemeSpaces.SPACE_NORM}px`,
      paddingBottom: ThemeSpaces.SPACE_XL,

      '> .TwoLinesSeparator.wide': {
        margin: `0 -${ThemeSpaces.SPACE_NORM}px`,
      },
    },
    pieceListPreviewRow: {
      display: 'flex',
      alignItems: 'center',

      '> .ant-row': {
        marginBottom: -ThemeSpaces.SPACE_NORM,
        '> .ant-col': {
          marginBottom: ThemeSpaces.SPACE_NORM,
        },
      },

      [`@media (min-width: ${token.screenLGMin}px)`]: {
        padding: ThemeSpaces.SPACE_NORM,
        paddingLeft: 0,
      },
      [`@media (max-width: ${token.screenMDMax}px)`]: {
        padding: `${ThemeSpaces.SPACE_NORM}px 0`,
      },

      '.number-in-circle': {
        marginRight: ThemeSpaces.SPACE_NORM_20,
      },
    },
  })
);
